export const buildColoredTooltipStyle = (color) => {
  return {
    backgroundColor: color,
    color: "white",
    borderRadius: "8px",
    padding: "6px 12px",
    fontSize: "13px",
    fontWeight: "500",
    boxShadow: `0 4px 12px ${color}66`,
  };
};
